module.exports = "../study/imgs/maps/Nagano/S8/Ecosystem/Avietchii/Nagano_Avietchii_GFDL_RCP45_Mid.png";